import { render, staticRenderFns } from "./ProfilesLinks.vue?vue&type=template&id=33ca7efb&scoped=true"
import script from "./ProfilesLinks.vue?vue&type=script&lang=js"
export * from "./ProfilesLinks.vue?vue&type=script&lang=js"
import style0 from "./ProfilesLinks.vue?vue&type=style&index=0&id=33ca7efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca7efb",
  null
  
)

export default component.exports